export default __webpack_public_path__ + "static/Roboto-Thin-a76225673323123d2989e5f159e45c52.ttf";